/*
    localhost : "http://localhost:8010"
    testhost : "http://192.168.0.2:8010"
*/

export const API_SERVER_HOST = process.env.REACT_APP_API_SERVER_HOST || "https://achieving-treasurer-screen-privilege.trycloudflare.com"; 

export const REDIRECT_HOST = process.env.REACT_APP_REDIRECT_HOST || "https://fastidious-toffee-be993e.netlify.app";

export const REST_API_KEY = process.env.REACT_APP_REST_API_KEY || "7cbd76ba5d**********aee484d9ceb3";

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || "7cbd76ba5d**********aee484d9ceb3";
